import { environment } from '../../../environments/environment';

const BASE_URL = environment.apiUrl;

export const API_ENDPOINTS = {
  auth: {
    sendOtp: `${BASE_URL}/auth/send-otp`,
    verifyEmail: `${BASE_URL}/auth/verify-email`,
    login: `${BASE_URL}/auth/login`,
    driverRegister: `${BASE_URL}/auth/driver/register`,
    vendorRegister: `${BASE_URL}/auth/pharmacy/register`,
    customerRegister: `${BASE_URL}/auth/customer/register`,
    forgotPassword: `${BASE_URL}/auth/forgot-password`,
    resetPassword: `${BASE_URL}/auth/reset-password`,
    changePassword: `${BASE_URL}/auth/change-password`,
    refreshToken: `${BASE_URL}/auth/refresh-token`,
    profile: `${BASE_URL}/auth/profile`,
  },
  pharmacyVendor: {
    profile: `${BASE_URL}/pharmacy-vendor/profile`,
    upcomingPayout: `${BASE_URL}/pharmacy-vendor/upcoming-payout`,
    driverPayments: `${BASE_URL}/pharmacy-vendor/driver-payments`,
    driverPaymentReceipt: (id: string) => `${BASE_URL}/driver-payments/${id}/receipt`,
    dashboard: `${BASE_URL}/pharmacy-vendor/dashboard`,
    dashboardStats: `${BASE_URL}/pharmacy-vendor/dashboard/stats`,
    paymentsChart: `${BASE_URL}/pharmacy-vendor/dashboard/payments-chart`,
    subscription: `${BASE_URL}/pharmacy-vendor/subscription`,
  },
  paymentsAdmin: {
    /** Admin: get all driver payments with full filtering and pagination */
    listAll: `${BASE_URL}/driver-payments/admin/all`,
    totals: `${BASE_URL}/driver-payments/admin/totals`,
    getById: (id: string) => `${BASE_URL}/driver-payments/${id}`,
  },
  driverPayments: {
    capturePayment: (paymentIntentId: string) => `${BASE_URL}/driver-payments/payment-intent/${paymentIntentId}/capture`,
  },
  // payouts: {

  // },
  driver: {
    profile: `${BASE_URL}/driver-profile`,
  },
  admin: {
    profile: `${BASE_URL}/admin-profile`,
  },
  drivers: {
    list: `${BASE_URL}/drivers`,
    create: `${BASE_URL}/drivers`,
    getById: (id: string) => `${BASE_URL}/drivers/${id}`,
    update: (id: string) => `${BASE_URL}/drivers/${id}`,
    delete: (id: string) => `${BASE_URL}/drivers/${id}`,
  },
  upload: {
    image: `${BASE_URL}/upload/image`,
  },
  verification: {
    list: `${BASE_URL}/verification`,
    toggle: (id: string) => `${BASE_URL}/verification/${id}/toggle`,
    archive: (id: string) => `${BASE_URL}/verification/${id}/archive`,
    unarchive: (id: string) => `${BASE_URL}/verification/${id}/unarchive`,
    pendingCount: `${BASE_URL}/verification/pending-count`,
  },
  pharmacies: {
    list: `${BASE_URL}/pharmacies`,
    create: `${BASE_URL}/pharmacies`,
    getById: (id: string) => `${BASE_URL}/pharmacies/${id}`,
    update: (id: string) => `${BASE_URL}/pharmacies/${id}`,
    delete: (id: string) => `${BASE_URL}/pharmacies/${id}`,
  },
  subscriptionPlans: {
    list: `${BASE_URL}/subscription-plans`,
    active: `${BASE_URL}/subscription-plans/active`,
    create: `${BASE_URL}/subscription-plans`,
    getById: (id: string) => `${BASE_URL}/subscription-plans/${id}`,
    update: (id: string) => `${BASE_URL}/subscription-plans/${id}`,
    delete: (id: string) => `${BASE_URL}/subscription-plans/${id}`,
  },
  settings: {
    list: `${BASE_URL}/settings`,
    bulkUpdate: `${BASE_URL}/settings/bulk`,
    getByKey: (key: string) => `${BASE_URL}/settings/${key}`,
    updateByKey: (key: string) => `${BASE_URL}/settings/${key}`,
  },
  gstRecords: {
    list: `${BASE_URL}/gst-records`,
    getById: (id: string) => `${BASE_URL}/gst-records/${id}`,
    stats: `${BASE_URL}/gst-management/stats`,
  },
  pharmacyCards: {
    list: `${BASE_URL}/pharmacy-cards`,
    create: `${BASE_URL}/pharmacy-cards`,
    setDefault: (id: string) => `${BASE_URL}/pharmacy-cards/${id}/default`,
    delete: `${BASE_URL}/pharmacy-cards`,
  },
  pharmacySubscriptions: {
    mySubscription: `${BASE_URL}/pharmacy-subscriptions/my-subscription`,
    plans: `${BASE_URL}/pharmacy-subscriptions/plans`,
    subscribe: `${BASE_URL}/pharmacy-subscriptions/subscribe`,
    changePlan: `${BASE_URL}/pharmacy-subscriptions/change-plan`,
    invoices: `${BASE_URL}/pharmacy-subscriptions/invoices`,
    invoiceById: (id: string) => `${BASE_URL}/pharmacy-subscriptions/invoices/${id}`,
    invoicePdf: (id: string) => `${BASE_URL}/pharmacy-subscriptions/invoices/${id}/pdf`,
    cancelMySubscription: `${BASE_URL}/pharmacy-subscriptions/cancel`,
    cancelSubscriptionAdmin: (id: string) => `${BASE_URL}/pharmacy-subscriptions/${id}/cancel`,
  },
  notifications: {
    adminAll: `${BASE_URL}/notifications/admin/all`,
    markRead: (id: string) => `${BASE_URL}/notifications/admin/${id}/read`,
    markAllRead: `${BASE_URL}/notifications/admin/mark-all-read`,
    unreadCount: `${BASE_URL}/notifications/unread-count`,
    /** Vendor (user-level) endpoints */
    vendorAll: `${BASE_URL}/notifications`,
    vendorMarkRead: (id: string) => `${BASE_URL}/notifications/${id}/read`,
    vendorMarkAllRead: `${BASE_URL}/notifications/mark-all-read`,
  },
  payouts: {
    adminStats: `${BASE_URL}/payouts/admin-stats`,
    vendorStats: `${BASE_URL}/payouts/vendor-stats`,
    myPayouts: `${BASE_URL}/payouts/my-payouts`,
    myPayoutById: (id: string) => `${BASE_URL}/payouts/my-payouts/${id}`,
    myPayoutStatementPdf: (id: string) => `${BASE_URL}/payouts/my-payouts/${id}/statement/pdf`,
    batches: `${BASE_URL}/payouts/batches`,
    batchById: (id: string) => `${BASE_URL}/payouts/batches/${id}`,
    deleteBatch: (id: string) => `${BASE_URL}/payouts/batches/${id}`,
    batchVendorById: (id: string) => `${BASE_URL}/payouts/batch-vendors/${id}`,
    batchVendorTransactions: (id: string) => `${BASE_URL}/payouts/batch-vendors/${id}/transactions`,
    batchVendorAuditInvoice: (id: string) => `${BASE_URL}/payouts/batch-vendors/${id}/audit-invoice/pdf`,
    markVendorPaid: (id: string) => `${BASE_URL}/payouts/batch-vendors/${id}/mark-paid`,
    exportBatchXlsx: (id: string) => `${BASE_URL}/payouts/batches/${id}/export/xlsx`,
    exportCombinedXlsx: (id: string) => `${BASE_URL}/payouts/batches/${id}/export/xlsx/combined`,
    exportBatchPdf: (id: string) => `${BASE_URL}/payouts/batches/${id}/export/pdf`,
    latest: `${BASE_URL}/payouts/latest`,
    calendar: `${BASE_URL}/payouts/calendar`,
    vendorCounts: `${BASE_URL}/payouts/vendor-counts`,
    generateSchedule: (scheduleId: string) => `${BASE_URL}/payouts/schedule/${scheduleId}/generate`,
  },
  expenses: {
    list: `${BASE_URL}/expenses`,
    create: `${BASE_URL}/expenses`,
    getById: (id: string) => `${BASE_URL}/expenses/${id}`,
    update: (id: string) => `${BASE_URL}/expenses/${id}`,
    delete: (id: string) => `${BASE_URL}/expenses/${id}`,
  },
  payoutAnalytics: {
    monthlyPayable: `${BASE_URL}/payout-analytics/monthly-payable`,
    feeTrends: `${BASE_URL}/payout-analytics/fee-trends`,
    topVendorsByEarnings: `${BASE_URL}/payout-analytics/top-vendors-by-earnings`,
  },
  designations: {
    list: `${BASE_URL}/designations`,
  },
  staff: {
    list: `${BASE_URL}/staff`,
    create: `${BASE_URL}/staff`,
    getById: (id: string) => `${BASE_URL}/staff/${id}`,
    update: (id: string) => `${BASE_URL}/staff/${id}`,
    delete: (id: string) => `${BASE_URL}/staff/${id}`,
    getPermissions: (id: string) => `${BASE_URL}/staff/${id}/permissions`,
    savePermissions: (id: string) => `${BASE_URL}/staff/${id}/permissions`,
  },
  ledger: {
    stats: `${BASE_URL}/ledger/stats`,
    entries: `${BASE_URL}/ledger/entries`,
  },
  analytics: {
    dashboardStats: `${BASE_URL}/analytics/dashboard-stats`,
    paymentGateway: `${BASE_URL}/analytics/payment-gateway`,
    incomeExpenseTrend: `${BASE_URL}/analytics/income-expense-trend`,
    subscriptionPlanDistribution: `${BASE_URL}/analytics/subscription-plan-distribution`,
    overview: `${BASE_URL}/analytics/overview`,
    profitSummary: `${BASE_URL}/analytics/profit-summary`,
    paymentsChart: `${BASE_URL}/analytics/payments-chart`,
    transactionStatus: `${BASE_URL}/analytics/transaction-status`,
    completedOrdersChart: `${BASE_URL}/analytics/completed-orders-chart`,
    hourlyDistribution: `${BASE_URL}/analytics/hourly-distribution`,
    topVendors: `${BASE_URL}/analytics/top-vendors`,
    gstSummary: `${BASE_URL}/analytics/gst-summary`,
    gstTrend: `${BASE_URL}/analytics/gst-trend`,
    revenueTrend: `${BASE_URL}/analytics/revenue-trend`,
    subscriptionSummary: `${BASE_URL}/analytics/subscription-summary`,
    subscriptionGrowth: `${BASE_URL}/analytics/subscription-growth`,
    financialOverview: `${BASE_URL}/analytics/financial-overview`,
    deliveryPartnerInsights: `${BASE_URL}/analytics/delivery-partner-insights`,
    recentSubscriptions: `${BASE_URL}/analytics/recent-subscriptions`,
    summaryCards: `${BASE_URL}/analytics/summary-cards`,
    revenueCards: `${BASE_URL}/analytics/revenue-cards`,
    revenueByCity: `${BASE_URL}/analytics/revenue-by-city`,
    provinces: `${BASE_URL}/analytics/provinces`,
    cities: `${BASE_URL}/analytics/cities`,
  },
};
